/**
 * Liaison onglets dashboard ↔ identifiants freemium (backend).
 * @module config/dashboardPremiumFeatures
 */

import { PREMIUM_FEATURE_IDS } from './constants';

/**
 * Onglet dashboard → id feature (null = pas de gate Premium sur cet onglet).
 * @type {Object.<string, string|null>}
 */
export const DASHBOARD_TAB_TO_PREMIUM_FEATURE_ID = {
  overview: null,
  rewards: PREMIUM_FEATURE_IDS.REWARDS_MANAGEMENT,
  spotify: PREMIUM_FEATURE_IDS.SPOTIFY_INTEGRATION,
  followed: PREMIUM_FEATURE_IDS.FOLLOWED_CHANNELS,
  mentions: PREMIUM_FEATURE_IDS.CHAT_MENTIONS,
  followssubs: PREMIUM_FEATURE_IDS.FOLLOWS_SUBS,
  streamstats: PREMIUM_FEATURE_IDS.STREAM_STATS,
  birthdays: PREMIUM_FEATURE_IDS.BIRTHDAYS,
  clips: PREMIUM_FEATURE_IDS.CLIPS,
  overlays: PREMIUM_FEATURE_IDS.OVERLAYS,
  commands: PREMIUM_FEATURE_IDS.ADVANCED_COMMANDS,
  ai: PREMIUM_FEATURE_IDS.AI_AUTO_INTERACTION,
  parameters: PREMIUM_FEATURE_IDS.PARAMETERS_PANEL,
};

/**
 * Libellés pour les volets PremiumGate (cohérents avec l’admin).
 * @type {Object.<string, string>}
 */
export const DASHBOARD_TAB_PREMIUM_LABELS = {
  rewards: 'L’onglet Récompenses',
  spotify: 'L’intégration Spotify',
  followed: 'Les chaînes suivies',
  mentions: 'Les mentions du chat',
  followssubs: 'Follows & abonnés',
  streamstats: 'Les statistiques de stream',
  birthdays: 'Les anniversaires',
  clips: 'Les clips',
  overlays: 'Les overlays',
  commands: 'L’édition des commandes',
  ai: 'La configuration IA',
  parameters: 'Les paramètres',
};

/**
 * @param {string} tab
 * @returns {string|null}
 */
export function getPremiumFeatureIdForDashboardTab(tab) {
  return DASHBOARD_TAB_TO_PREMIUM_FEATURE_ID[tab] ?? null;
}
